import { Controller } from 'stimulus'
import {
  setPlayerCurrentTime,
  waitForPlayer,
} from '~/common/components/videojs/helpers'

export default class extends Controller {
  static values = {
    playerSelector: String,
  }

  async jumpToTime(e) {
    const player = await waitForPlayer(
      document.querySelector(this.playerSelectorValue)
    )
    setPlayerCurrentTime(player, e.params.position, { playAfterSeek: true })
  }
}
